import type {CalculateParams} from '../types'
import {convertHeightToPx} from '../converters/height'
import type {GridContainerLayout} from '@wix/document-services-types'

export const calculateRows = (calculateParams: CalculateParams): void => {
    const {measurementsMapAPI, compRef, layoutData} = calculateParams
    const {get, set} = measurementsMapAPI
    if (get.rows(compRef) !== undefined) {
        return
    }

    const rows = (layoutData?.containerLayout as GridContainerLayout)?.rows
    if (!rows) return

    const rowsInPx: number[] = []
    rows.forEach(row =>
        rowsInPx.push(
            convertHeightToPx[row.type]({
                ...calculateParams,
                ...row
            })
        )
    )
    set.rows(compRef, rowsInPx)
}
